import { render, staticRenderFns } from "./linkedContacts.vue?vue&type=template&id=1b81b58a"
import script from "./linkedContacts.vue?vue&type=script&lang=js"
export * from "./linkedContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports